import { render, staticRenderFns } from "./TreatmentPhase.vue?vue&type=template&id=43b1f7e4&scoped=true&"
import script from "./TreatmentPhase.vue?vue&type=script&lang=js&"
export * from "./TreatmentPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b1f7e4",
  null
  
)

export default component.exports